module.exports = __webpack_public_path__ + "img/electronic_use.dbf64832.svg";